export default {
    SEARCH_USER: `merchants/client/search/v2/`,
    SEARCH_ALIAS: "merchants/client/search/by-alias/"
}